import { DataTable } from 'components/DataTable';

import {
    embeddedUsersColumns,
    type EmbeddedUserRow,
    type EmbeddedUsersFilterInput,
} from 'pages/Users/constants/embeddedUsersColumns';

const defaultFilters: EmbeddedUsersFilterInput = {
    searchValue: '',
    states: [],
};

// Client-side users DataTable embedded in a details page (organization or totem). Data is fetched once by the
// parent (all users of the organization) and filtered/split in-memory.
export const EmbeddedUsersTable = ({
    users,
    emptyMessage = 'Aucun utilisateur',
    searchPlaceholder = 'Nom, email…',
}: {
    users: EmbeddedUserRow[];
    emptyMessage?: string;
    searchPlaceholder?: string;
}) => {
    // Grow with the number of users but cap it so the section stays compact.
    const tableHeight = Math.min(600, 200 + users.length * 48);

    return (
        <div style={{ height: tableHeight }} className="flex w-full flex-col overflow-hidden">
            <DataTable<EmbeddedUserRow, EmbeddedUsersFilterInput>
                columns={embeddedUsersColumns}
                data={users}
                filterMode="client"
                getRowId={(row) => row._id}
                getRowLink={(row) => `/user/${row._id}`}
                defaultFilters={defaultFilters}
                searchPlaceholder={searchPlaceholder}
                searchFilterKey="searchValue"
                autoFocusSearch={false}
                disableUrlSync
                emptyMessage={emptyMessage}
                enableVirtualization
            />
        </div>
    );
};
